import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState, BatchAction } from '../../../types/store';
import { cancelBatchAction } from '../../../actions/studio';
import { Props } from './DesktopBatchActionWrapper';
import { getBatchAction, getSelectedRowCount } from '../../../selectors/studio';

export type StateProps = Pick<Props, 'batchAction' | 'selectedCount'>;
export type DispatchProps = Pick<Props, 'onCancel'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  batchAction: getBatchAction(state) as BatchAction,
  selectedCount: getSelectedRowCount(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  onCancel: () => dispatch(cancelBatchAction()),
});

export default connect(mapStateToProps, mapDispatchToProps);
